import { render, staticRenderFns } from "./EditOrder/template.html?vue&type=template&id=7205ef5d&scoped=true&"
import script from "./EditOrder/script.ts?vue&type=script&lang=js&"
export * from "./EditOrder/script.ts?vue&type=script&lang=js&"
import style0 from "./EditOrder/style.scss?vue&type=style&index=0&id=7205ef5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205ef5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
